const scopes = {
  patientNotes: "patientNotes",
  appointmentNotes: "appointmentNotes",
  rxNotes: "rxNotes",
};

export const notesKeys = {
  patientNotes: {
    scope: scopes.patientNotes,
    all: () => [scopes.patientNotes] as const,
    detail: (patientId: string) => [scopes.patientNotes, { patientId }] as const,
  },
  appointmentNotes: {
    scope: scopes.appointmentNotes,
    all: () => [scopes.appointmentNotes] as const,
    detail: (appointmentId: string) => [scopes.appointmentNotes, { appointmentId }] as const,
  },
  rxNotes: {
    scope: scopes.rxNotes,
    all: () => [scopes.rxNotes] as const,
    detail: (rxId: string) => [scopes.rxNotes, { rxId }] as const,
  },
};
